import header from "./header";
import stage from "./stage";

header.init();
stage.init();
